import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';


export const useWarehouseStateChange = (lcrId) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(
    ({ warehouseId, operation }) => axiosInstance.put(liveCleanroom(orgId)
      .warehouseStateChange(lcrId, warehouseId), { operation }),
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries({ queryKey: ['warehouseList', lcrId] });
        const operationText = variables.operation === 'SUSPEND' ? 'suspended' : 'resumed';
        dispatch(showAlert({
          message: `Warehouse ${operationText} successfully`,
          type: 'success',
        }));
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error changing warehouse state',
            type: 'error',
          }),
        );
      },
    },
  );
};
